// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"style_tableWrapper__2YtTy","tableTitle":"style_tableTitle__3oHLe"};